// 投注類型映射 - betContent 值對應顯示名稱
export const BET_CONTENT_MAP = {
  // 和值
  sum_3: '和值3',
  sum_4: '和值4',
  sum_5: '和值5',
  sum_6: '和值6',
  sum_7: '和值7',
  sum_8: '和值8',
  sum_9: '和值9',
  sum_10: '和值10',
  sum_11: '和值11',
  sum_12: '和值12',
  sum_13: '和值13',
  sum_14: '和值14',
  sum_15: '和值15',
  sum_16: '和值16',
  sum_17: '和值17',
  sum_18: '和值18',
  
  // 三同號單選
  triple_single_111: '三同號單選111',
  triple_single_222: '三同號單選222',
  triple_single_333: '三同號單選333',
  triple_single_444: '三同號單選444',
  triple_single_555: '三同號單選555',
  triple_single_666: '三同號單選666',
  
  // 三同號通選
  triple_all: '三同號通選',
  
  // 三不同號
  three_different: '三不同號',
  
  // 三連號通選
  three_consecutive: '三連號通選',
  
  // 二同號單選
  double_single_11: '二同號單選11',
  double_single_22: '二同號單選22',
  double_single_33: '二同號單選33',
  double_single_44: '二同號單選44',
  double_single_55: '二同號單選55',
  double_single_66: '二同號單選66',
  
  // 二同號復選
  double_multiple_11: '二同號復選11',
  double_multiple_22: '二同號復選22',
  double_multiple_33: '二同號復選33',
  double_multiple_44: '二同號復選44',
  double_multiple_55: '二同號復選55',
  double_multiple_66: '二同號復選66',
  
  // 二不同號
  two_different: '二不同號',
  
  // 單骰
  single_dice_1: '單骰1',
  single_dice_2: '單骰2',
  single_dice_3: '單骰3',
  single_dice_4: '單骰4',
  single_dice_5: '單骰5',
  single_dice_6: '單骰6',
  
  // 大小
  big: '大',
  small: '小',
  
  // 單雙
  odd: '單',
  even: '雙',
} as const

// betType 對應的分類
export const BET_TYPE_CATEGORIES = {
  sum: 'sum',
  triple_single: 'triple_single',
  triple_all: 'triple_all',
  three_different: 'three_different',
  three_consecutive: 'three_consecutive',
  double_single: 'double_single',
  double_multiple: 'double_multiple',
  two_different: 'two_different',
  single_dice: 'single_dice',
  big_small: 'big_small',
  odd_even: 'odd_even'
} as const

export type BetContent = keyof typeof BET_CONTENT_MAP
export type BetTypeCategory = keyof typeof BET_TYPE_CATEGORIES

// 單個投注項目
export interface PlaceFastThreeBetCmd {
  betType: string      // 投注分類，如: "sum", "triple_single", "big_small" 等（對應後台 bet_type）
  betContent: string   // 投注規則代碼，如: "sum_3", "triple_single_111", "big" 等（對應後台 rule_code）
  betAmount: number
}

// 投注請求數據
export interface PlaceBetCmd {
  gameType: 'fast3'
  periodId: number
  fast3Bet: PlaceFastThreeBetCmd[]
}

export interface GameRuleDTO {
  id: number;
  gameTypeId: number;
  ruleCode: string;
  betType: string;
  odds: number;
  minBetAmount: number;
  maxBetAmount: number;
  status: number;
}


// 投注項目（用於前端顯示）
export interface BetItem {
  betType: string
  betContent: string
  displayName: string
  amount: number
}

// 賠率配置（根據後台 DML 數據）
export const ODDS_CONFIG: Record<string, string> = {
  // 和值玩法 - 賠率根據後台 DML
  sum_3: '1:240',
  sum_4: '1:80', 
  sum_5: '1:40',
  sum_6: '1:25',
  sum_7: '1:16',
  sum_8: '1:12',
  sum_9: '1:9.5',
  sum_10: '1:9',
  sum_11: '1:9',
  sum_12: '1:9.5',
  sum_13: '1:12',
  sum_14: '1:16',
  sum_15: '1:25',
  sum_16: '1:40',
  sum_17: '1:80',
  sum_18: '1:240',
  
  // 三同號玩法
  triple_single_111: '1:240',
  triple_single_222: '1:240',
  triple_single_333: '1:240',
  triple_single_444: '1:240',
  triple_single_555: '1:240',
  triple_single_666: '1:240',
  triple_all: '1:40',
  
  // 其他玩法
  three_different: '1:40',
  three_consecutive: '1:20',
  
  // 二同號玩法
  double_single_11: '1:80',
  double_single_22: '1:80', 
  double_single_33: '1:80',
  double_single_44: '1:80',
  double_single_55: '1:80',
  double_single_66: '1:80',
  double_multiple_11: '1:15',
  double_multiple_22: '1:15',
  double_multiple_33: '1:15',
  double_multiple_44: '1:15',
  double_multiple_55: '1:15',
  double_multiple_66: '1:15',
  
  // 二不同號和單骰
  two_different: '1:8',
  single_dice_1: '1:1（按出現次數賠付）',
  single_dice_2: '1:1（按出現次數賠付）',
  single_dice_3: '1:1（按出現次數賠付）',
  single_dice_4: '1:1（按出現次數賠付）',
  single_dice_5: '1:1（按出現次數賠付）',
  single_dice_6: '1:1（按出現次數賠付）',
  
  // 大小和單雙 - 注意後台是 1.96 賠率
  big: '1:1.96',
  small: '1:1.96',
  odd: '1:1.96',
  even: '1:1.96',
}

// 投注记录查询参数接口
export interface BetRecordQry {
  userId?: number
  gameCode?: string
  periodId?: number
  betType?: string
  betStatus?: number // 1-有效，2-无效，3-已结算
  winStatus?: number // 0-未开奖，1-中奖，2-未中奖
  startDate?: string // 格式: YYYY-MM-DD
  endDate?: string   // 格式: YYYY-MM-DD
  pageIndex?: number // 页码（从1开始）
  pageSize?: number  // 每页数量
  total?: number
}

// 投注记录DTO接口
export interface BetRecordDTO {
  betId: number
  userId: number
  periodId: number
  periodNo: string
  gameCode: string
  gameName: string
  betType: string
  betTypeName: string
  betContent: string
  betAmount: number
  odds: number
  possibleWinAmount: number
  actualWinAmount: number
  betTime: number
  drawTime?: number
  settleTime?: number
  betStatus: number // 1-有效，2-无效，3-已结算
  winStatus: number // 0-未开奖，1-中奖，2-未中奖
  winningNumbers?: string
  periodStatus: number
}